export default __webpack_public_path__ + "static/media/Loading-Img.efd19236.gif";